import { render } from "./ReviewScore.vue?vue&type=template&id=00793bee&scoped=true"
import script from "./ReviewScore.vue?vue&type=script&lang=js"
export * from "./ReviewScore.vue?vue&type=script&lang=js"

import "./ReviewScore.vue?vue&type=style&index=0&id=00793bee&lang=scss&scoped=true"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00793bee"]])

export default __exports__